export default (theme) => ({
  form: {
    width: '100%',
  },
  input: {
    width: '100%',
    marginTop: 5,
    '&:first-of-type': {
      marginTop: 15,
    },
  },
  error: {
    width: '100%',
    color: theme.palette.error.main,
    textAlign: 'center',
  },
  submit: {
    marginTop: 25,
    width: '100%',
    minHeight: 45,
  },
});
